import React, { useEffect } from 'react';

function SocialMediaStrategie() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main id="main-content" role="main">
      {/* Hero Section */}
      <section className="hero hero--small">
        <div className="container">
          <div className="hero__content">
            <div className="hero__text">
              <h1 className="hero__title">
                Social Recruiting Agentur: Fachkräfte finden mit Social Media Recruiting in <span className="hero__highlight">Berlin</span>
              </h1>
              <p className="hero__subtitle">
                Als spezialisierte Social Recruiting Agentur helfen wir Recruiting Agenturen und Unternehmen dabei, qualifizierte Mitarbeiter über jeden Kanal zu gewinnen. Warum Social Media Recruiting? Weil Sie gezielt Fachkräfte ansprechen und Ihr Unternehmen als attraktiven Arbeitgeber positionieren können. Unsere Social Recruiting Agentur in Berlin bietet maßgeschneiderte Lösungen im Bereich Social Media Recruiting, um den Fachkräftemangel zu bekämpfen und die besten Talente für Ihr Unternehmen zu finden.
              </p>
              <p className="hero__description">
                In diesem Leitfaden erfahren Sie alles über erfolgreiches Social Recruiting und Employer Branding. Von der Recruiting Strategie über gezielte Kampagnen bis hin zu Best Practices – wir zeigen Ihnen, wie Sie beim Social Recruiting in Berlin erfolgreich sind und qualifizierte Bewerber für offene Stellen gewinnen. Lassen Sie uns gemeinsam Ihre Recruiting Maßnahmen optimieren und neue Mitarbeiter zu finden.
              </p>
              <div className="hero__cta">
                <button className="btn btn--primary btn--large" data-open-consultation data-source="Hero CTA" style={{background: '#a387c1', color: 'white', fontWeight: 700}}>
                  Kostenloses Erstgespräch
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="content-section">
        <div className="container">
          <div className="content-grid">
            <div className="content-text">
              
              {/* H2 Section 1 */}
              <h2>Warum Social Media Recruiting für Unternehmen in Berlin unverzichtbar ist</h2>
              <p>
                Social Recruiting hat sich in den letzten Jahren zur effektivsten Methode entwickelt, um qualifizierte Fachkräfte zu finden. Als Social Media Recruiting Agentur verstehen wir, dass traditionelle Stellenanzeigen allein nicht mehr ausreichen, um die besten Talente zu erreichen. Der Arbeitsmarkt hat sich fundamental verändert – potenzielle Kandidaten verbringen mehr Zeit auf plattformen wie LinkedIn, Instagram und Facebook als auf klassischen Jobbörsen. Social Recruiting ermöglicht es Ihnen, gezielt Bewerber anzusprechen, wo sie ihre Zeit verbringen.
              </p>
              <p>
                Unserer Social Recruiting Agentur liegt es am Herzen, Unternehmen dabei zu helfen, den Recruiting Prozess zu revolutionieren. Durch den Einsatz von social media können Sie nicht nur eine größere Reichweite erzielen, sondern auch authentisch Ihre Arbeitgebermarke präsentieren. Im Bereich Social Media Recruiting nutzt man die Nutzen von Social Media, um eine gezielte Ansprache zu ermöglichen und passive Kandidaten zu erreichen, die nicht aktiv auf Jobsuche sind, aber für das eigene Unternehmen passen könnten.
              </p>
              <p>
                Warum Social Recruiting so effektiv ist: Es ermöglicht eine persönliche Ansprache der Zielgruppe, fördert Employer Branding und schafft Vertrauen. Als eine der führenden Recruiting Agenturen in Berlin haben wir festgestellt, dass Social Recruiting Kampagnen durchschnittlich 40% mehr qualifizierte Bewerbungen generieren als traditionelle Methoden. Die Kombination aus gezielten Ads, organischem Content und innovativen Kampagnen macht unsere Social Recruiting Agentur zum idealen Partner für Ihr Unternehmen.
              </p>

              <div className="stats-grid">
                <div className="stat-box">
                  <span className="stat-box__number">40%</span>
                  <span className="stat-box__label">mehr qualifizierte Bewerbungen</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">60%</span>
                  <span className="stat-box__label">schnellere Time-to-Hire</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">3x</span>
                  <span className="stat-box__label">höhere Reichweite</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">15+</span>
                  <span className="stat-box__label">Jahre Erfahrung</span>
                </div>
              </div>

              {/* Summary */}
              <h2>Zusammenfassung: Die wichtigsten Punkte für erfolgreiches Social Recruiting</h2>
              <p>
                Social Recruiting ist die effektivste Methode, um qualifizierte Mitarbeiter im digitalen Zeitalter zu gewinnen. Mit der richtigen Strategie, professioneller Unterstützung und kontinuierlicher Optimierung können Sie den Fachkräftemangel bekämpfen und die besten Talente für sich gewinnen. Hier die wichtigsten Erkenntnisse:
              </p>
              <ul className="summary-list">
                <li><strong>Social Recruiting übertrifft traditionelle Methoden</strong> – 40% mehr qualifizierte Bewerbungen und deutlich niedrigere Kosten pro Einstellung</li>
                <li><strong>Multi-Channel-Ansatz ist entscheidend</strong> – Die Kombination aus LinkedIn, Facebook und Instagram erreicht unterschiedliche Zielgruppen</li>
                <li><strong>Employer Branding ist das Fundament</strong> – Eine starke Arbeitgebermarke zieht automatisch mehr und bessere Talente an</li>
                <li><strong>Gezielte Ansprache statt Gießkanne</strong> – Präzises Targeting stellt sicher, dass nur qualifizierte Kandidaten Ihre Stellenanzeigen sehen</li>
                <li><strong>Video-Content wird zum Standard</strong> – Authentische Videos erzeugen mehr Engagement</li>
                <li><strong>Messbarkeit ermöglicht kontinuierliche Optimierung</strong> – Durch detailliertes Tracking können wir jede Kampagne verbessern</li>
                <li><strong>Personalisierung erhöht Bewerbungsqualität</strong> – Individuelle Ansprachen führen zu relevanteren Bewerbungen</li>
                <li><strong>Dialog statt Monolog</strong> – Aktive Kommunikation mit Kandidaten verbessert die Candidate Experience</li>
                <li><strong>Passive Kandidaten sind der Schlüssel</strong> – Die besten Talente können über Social Media erreicht werden</li>
                <li><strong>Expertise macht den Unterschied</strong> – Eine spezialisierte Agentur bringt die nötige Erfahrung mit</li>
                <li><strong>Lokale Marktkenntnis ist wertvoll</strong> – Besonders in Berlin hilft lokale Expertise beim Recruiting-Erfolg</li>
                <li><strong>Integration von Recruiting und Employer Branding</strong> – Die Verzahnung führt zu nachhaltigem Recruiting-Erfolg</li>
              </ul>

              <div className="cta-box">
                <h3>Bereit für erfolgreiches Social Recruiting?</h3>
                <p>
                  Als führende Social Recruiting Agentur in Berlin unterstützen wir Sie dabei, qualifizierte Mitarbeiter über Social Media zu gewinnen. Von der Strategie über die Umsetzung bis zur Erfolgsmessung – wir übernehmen alle Aspekte Ihres Social Media Recruitings. Lassen Sie uns gemeinsam Ihr Recruiting auf das nächste Level heben.
                </p>
                <button className="btn btn--primary btn--large" data-open-consultation data-source="Content CTA" style={{background: '#a387c1', color: 'white', fontWeight: 700}}>
                  Jetzt kostenloses Erstgespräch vereinbaren
                </button>
              </div>
            </div>

            <div className="content-sidebar">
              <div className="sidebar-widget">
                <h3>Social Recruiting Vorteile</h3>
                <ul>
                  <li>✓ 40% mehr qualifizierte Bewerbungen</li>
                  <li>✓ Niedrigere Cost-per-Hire</li>
                  <li>✓ Gezielte Kandidatenansprache</li>
                  <li>✓ Stärkere Arbeitgebermarke</li>
                  <li>✓ Zugang zu passiven Kandidaten</li>
                  <li>✓ Messbare Ergebnisse</li>
                  <li>✓ Schnellere Time-to-Hire</li>
                </ul>
              </div>

              <div className="sidebar-widget">
                <h3>Unsere Services</h3>
                <ul>
                  <li>Social Recruiting Strategie</li>
                  <li>Employer Branding</li>
                  <li>Social Media Ads</li>
                  <li>Content Creation</li>
                  <li>Community Management</li>
                  <li>Analytics & Reporting</li>
                  <li>Candidate Nurturing</li>
                </ul>
              </div>

              <div className="sidebar-widget">
                <h3>Erfolgsbeispiele</h3>
                <p>Über 500 erfolgreiche Recruiting-Projekte für Unternehmen wie:</p>
                <ul>
                  <li>Vattenfall</li>
                  <li>REWE</li>
                  <li>Casio</li>
                  <li>AutoHero</li>
                </ul>
              </div>

              <div className="sidebar-widget">
                <h3>Kontakt</h3>
                <p>
                  famefact Social Recruiting Berlin<br />
                  Schliemannstraße 23<br />
                  10437 Berlin<br />
                  <a href="tel:+4930403665430">030 403 665 430</a><br />
                  <a href="mailto:info@social-recruiting-berlin.de">info@social-recruiting-berlin.de</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section" style={{background: 'linear-gradient(135deg, #a387c1 0%, #C9B1D3 100%)', padding: '6rem 0'}}>
        <div className="container">
          <h2 className="cta-title" style={{color: 'white', textAlign: 'center', marginBottom: '1rem', fontSize: '2.5rem'}}>
            Starten Sie jetzt mit Social Recruiting!
          </h2>
          <p className="cta-subtitle" style={{color: 'rgba(255, 255, 255, 0.9)', textAlign: 'center', fontSize: '1.25rem', marginBottom: '3rem'}}>
            Vereinbaren Sie ein kostenloses Erstgespräch und erfahren Sie, wie unsere Social Recruiting Agentur Ihnen helfen kann, die besten Fachkräfte für Ihr Unternehmen zu gewinnen.
          </p>
          <div className="cta-buttons" style={{textAlign: 'center'}}>
            <a href="#" className="btn btn--primary btn--large" data-open-consultation data-source="Bottom CTA" style={{background: 'white', color: '#333333', fontWeight: 700, display: 'inline-block', textDecoration: 'none'}}>
              Kostenloses Erstgespräch vereinbaren
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}

export default SocialMediaStrategie;
